<template>
  <b-form-group
    :id="formGroupId"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <b-form-select
      v-model="selectedState"
      :options="options"
      :selected="selected"
      @change="showState($event)"
      :state="state"
      :disabled="isDisabled"
    ></b-form-select>
  </b-form-group>
</template>

<script>
import states from '@/lib/data/states';

function loadStates(optionsArr) {
  for (var stateCode in states) {
    optionsArr.push({ value: stateCode, text: states[stateCode] });
  }
}
export default {
  name: 'SelectListStates',
  props: {
    selected: {
      default: '', // e.g. on ImageUpload (NOT edit text page), no need to have ':selected' attribute on tag in template. The
      // first item in the options list WILL be selected, i.e. 'Select state...'
    },
    id: {},
    label: {},
    state: {
      default: null,
    },
    errorMsg: {},
    disabled: null,
  },
  data: function () {
    return {
      options: [],
    };
  },
  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    isDisabled: function () {
      return this.disabled;
    },
    selectedState: {
      get: function () {
        return this.selected;
      },
      set: function (stateCode) {
        return stateCode;
      },
    },
  },

  methods: {
    showState: function (val) {
      // console.log('state val is', val);
      this.$emit('state-selected', val);
    },
  },

  created() {
    this.options.push({ value: '', text: 'Select your state...' });
    loadStates(this.options);
  },
};
</script>

<style>
</style>